/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![CheckmarkLargeIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAuUlEQVR4nO3UOw7CMAwG4EogMSPxPE3WiNatM1g2j9OywFAGoIgTcA6QeUl0qFqRLlX+Of2sNH8SRSEhTeLcZpJmcgCUbTs4cpGi3NNMdv7xTM5PHPmYJMtRB3Fr7cAY06+LA8j0+8/r4IB80wZYorFXXENEPcX1A0A+VQ2BpvgncbwaAnL+qhlfF0Sz8pq/D7Q8xLn13BteNcT5rqICCr3BAlAu3nv+sxNs4RJpFATkvb4t3vGQ7uQBijaQ5w45LNsAAAAASUVORK5CYII=)
 */
export const CheckmarkLargeIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.7 5.3a1 1 0 0 1 0 1.4l-12 12a1 1 0 0 1-1.4 0l-6-6a1 1 0 1 1 1.4-1.4L9 16.58l11.3-11.3a1 1 0 0 1 1.4 0Z"
        className={colorClass}
      />
    </svg>
  );
};
